import './modules/register-service-worker';
import { branchBar } from '@crasman/branch-bar';
import '@crasman/branch-bar/styles.css';
import 'es6-promise/auto';
import axios from 'axios';
import initConfig from './modules/config';
import covid from './modules/covid';
import loader from './modules/loader';

import dropdown from './modules/dropdown';
import navigation from './modules/navigation';

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();

const page = document.getElementById('pages');
loader.start(page);

window.config = initConfig();

navigation.init();
dropdown.init();
covid.init();

/*
axios({
    method: 'get',
    url: '/stage-ajax/get-covid/',
    responseType: 'json',
    params: {
        summary: true,
        firstDate: window.config.dataFirstDate.format('YYYY-MM-DD'),
        dataTimestamp: window.config.dataTimestamp
    }
}).then(function (response) {
    covid.initData(response.data);
    loader.end(page);
});


axios({
    method: 'get',
    url: '/stage-ajax/getCorona/',
    responseType: 'json',
    params: {
        initial: true,
        firstDate: window.config.dataFirstDate.format('YYYY-MM-DD'),
        dataTimestamp: window.config.dataTimestamp
    }
}).then(function (response) {
    covid.initData(response.data);
    loader.end(page);
});
*/
